<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Viga&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap');
@font-face {
  font-family: 'Happy Times';
  src: url('../../../fonts/happy-times-NG_regular_master.otf');
}
@font-face {
  font-family: 'Semi Light Dots';
  src: url('../../../fonts/AC1-SemiLightDots.otf');
}
@font-face {
  font-family: 'Monospaced Dots';
  src: url('../../../fonts/AC1-Monospaced.otf');
}
@font-face {
  font-family: 'Bold Big Dots';
  src: url('../../../fonts/AC1-BoldBigDots.otf');
}
@font-face {
  font-family: 'ED Regular';
  src: url('../../../fonts/ED-Regular.otf');
}

* {
    border: 0px black solid;
    background-color: transparent;
}

.container_width {
  max-width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 70px;
}


a:hover {
  color: hotpink;
  text-decoration: none;
}

a {
  color: gray;
}

.content {
  /*padding-right: 50px;*/
  /*padding-left: 60px;*/
  font-family: 'Happy Times';
  font-size: 18px;
  line-height: 24px;
  /*padding-bottom: 40px;*/
  color: #1B75BC;
  text-align: left;
}

.controls {
  padding-top: 12px;
  height: 120px;
  z-index: 1;
  position: relative;
  }

.title_story {
  font-size: 80px;
  font-family: 'Semi Light Dots', sans-serif;
  padding-top: 20px;
  color: #FA00FF;
  text-align: center;
}

.arrows {
  font-size: 80px;
  font-family: 'Semi Light Dots', sans-serif;
  top: 36px;
  color: #FA00FF;
  vertical-align: top;
  position: fixed;
  overflow: hidden;
}

.arrows a {
    display: block;
}

#leftarrow {
  float: left;
  color: #FA00FF;
}

#rightarrow {
  float: right;
  color: #FA00FF;
}

.image_container {
  padding-top: 5px;
}

.photo {
-webkit-filter: grayscale(100%);
        filter: grayscale(100%);
        width: auto;
  max-height: 100%;
  max-width: 100%;
  padding: 12px;
}

.img-fluid {
  filter: sepia(100%) saturate(300%) brightness(100%) hue-rotate(270deg);
  max-height: 100%;
  max-width: 100%;
  }

.author {
  font-size: 20px;
  font-family: 'ED-regular', sans-serif;;
  text-align: center;
  color: #FA00FF;
}

.recipe_block {
  padding: 18px;
  margin-bottom: 18px;
  font-size: 15px;
  font-family: 'Monospaced Dots', monospace;
  border: 6px dotted #FA00FF;
  /*margin-bottom: 24px;*/
}

#aniseillu {
  margin-left: 20%;
  margin-bottom: 0px;
}

.recipe_title {
  font-family: 'Bold Big Dots', monospace;
  font-size: 200%;
  line-height: 130%;
  padding-bottom: 18px;

}

.recipe {
  margin-top: 20px;
  font-weight: bold;
}

.small_icon {
  max-width: 60%;
  padding-top: 100px;
}

.zoom {
  max-width: 100%;
}

@media (max-width: 575px){
     .small_icon {
       display: none;

     }
     .title_story {
       font-size: 48px;
     }
     .author {
       font-size: 21px;
     }
   }

</style>

<template>
  <b-container fluid class="p-0">
    <MenuBar/>
    <b-row class="controls">
      <b-col md="12" class="arrows">
        <a href="/lychee" id="leftarrow">←</a>
        <a href="/" id="rightarrow">→</a>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4">
        <b-row>
          <b-col md="6" offset-md="3">
            <div class="zoom">
              <b-img center class="img-fluid" alt="Responsive image" src="media/magiun2/anise.png"> </b-img>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
          <p class="title_story">Adapting to Adaptations</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <p class="author">essay and recipes by Inge Hoonte</p>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="5">
        <div class='content'>
          <p>The majority of my cooking consists of throwing together whatever's in my fridge and cupboards. And, gladly, what I've grown or surprisingly harvested from the yard that came with my new apartment!*</p>
          <p>The last years, but even more so these months, I rarely shop for precise ingredients to make a specific dish.**</p>
          <p>If I have guests over for dinner, I tend to make more of an effort, and I sometimes regret not making such an effort for myself. With a handful (or two) of exceptions, I have spent this past year cooking and eating solo.***</p>
          <p> I don't mean to make that sound sadder than it is, it is how it is, but I do miss having friends over and eating together...****</p>
          <p>EXCEPTIONS TO ADAPTATIONS THAT ARE STILL ADAPTATIONS</p>
          <p>Like most people, the way I cook (and shop) has changed. It's more sparse, probably a bit boring, and at the same time more creative as I replace ingredients with what I have. Getting a "want/need/crave" item around meal times is no longer part of my life. In the beginning of the pandemic, I was that woman retreating, jumping back or even running away when people approached. The woman who snapped at people, and had to calm down in the quietest part of the store (if you're in need, try the dietary restriction or health food section). For a couple months, I only went to one store, close by, where I knew where everything was, so I could go in and out as fast as I could. A friend jokingly called me an old lady, I call it taking care of my mental health. I soon began shopping in the morning when it's more quiet (yep, right after granny hour), and almost a year later I still don't go around peak hours. I don't plan meals, I just grab a variety of fruit and veggies for up to a week, and add tofu, seitan, tempeh, lentils and beans, sometimes a fun (though generally low in protein) burger or an add-water-nut-burger-mix. The downside is that my meals could use a bit more spice and spunk, the upside is that I buy and eat way less candy, chocolate, cookies, chips and dessert-type things. *****</p>
          <p>With baking, it usually starts something like this:</p>
          <p>I have a couple overripe bananas that have been sitting there for a few days, so I make banana bread (which I bring on my bike rides). I adapt the recipe with peanut butter, nuts, cocoa powder, raisins, dates, whatever I have and feel like adding.</p>
          <p>Or a friend sends me a message that she's eating chocolate with green tea flavor. This leaves me craving ginger flavored chocolate, but the buying of ingredients will have to wait until the less crowded morning. Super fun to make though! See details below.</p>
          <p>Or: last week after dinner, I suddenly felt like a sweet dessert. I didn't have anything readymade but I did have chocolate sprinkles, flour and oatmeal. So I looked up a recipe for cookies and started dragging the main ingredients out of the cupboards. A word of warning: although it's fun to try, you cannot just simply replace ingredients that seem similar. I've made scones with coconut creme instead of soyghurt. Not a great idea. I've subbed flour with some leftover coconut flour. Not a good idea either. The consistency requires other adaptations, and it all ends up being a wet, soggy mess. Other times adapting recipes works out great though! Chocolate sprinkle cookies.</p>
          <p>* One big adaptation has been cooking with edible weeds from the garden. When I got here, the soil was covered with stinging nettles, which I removed. The next season, instead of nettles, a strange looking fragile little green thing came up, growing small thin leaves. When it started to get bigger and the field more massive, I finally realized I hadn't sown this, and that it was probably weed. I sent some pictures to my sister, who did some googling and thought it was an edible weed. I installed an app that helps identify plants, and figured out it was goose foot (melganzevoet), which people were growing and eating up until the 1950s, when it was replaced by the more sturdy and supermarket-friendly version: spinach. Goose foot is very similar to spinach, and rich in nutrients. I even ended up trading it for bread, with a neighbor who likes to bake.</p>
          <p>** My mom gave me some vouchers for free vegetarian groceries. In the envelope she sent were some very uninteresting, basic vegetarian recipe cards, but there was one I hadn't made for a long time: lasagna. I easily adapted it from vegetarian to vegan, and used the purslane we got at the food coop.</p>
          <p>*** With some non-spicy portions of my veggies to give to the cats. Of course I do research on what they're allowed to have, in small doses, and they were very interesting in trying pumpkin, sweet potato and broccoli. They want in on a lot of fruits as well. So far they've tried mango, pear, strawberry, kiwi, lychee, and kaki fruit.</p>
          <p>**** But the main exception this past year is my <b>quest to copy Coppi's coconut macaroons</b>. They sell them at Coppi Koffie on the Bergweg, and I love them so much that when I felt less comfortable going out in March/April 2020, I started making them myself. The first time, I made them for a friend's 40th birthday in April. Instead of a fun celebration in the park, her birthday weekend was a super stressful stay-at-home version of a Christmas dinner, where she was catering to all of her family, and her boyfriend's family. The typical running around serving everybody on your own day. So we went for a "distance walk," and ate coconut cookies. This version followed a recipe that adds flour, so they weren't macaroons at all, but crisp cookies. Slightly failed and stale, actually, although Ilse assured to thank me for this birthday gift.</p>
          <p>I have made them four times now (I got distracted by copying Spirit's scones), and tried a different recipe each time. I'm not even remotely close to Elise's version at all. Not even after I told her that if I can make these, and make them well, all the corona isolation will have had at least some... productive outcome, upon which she revealed her ingredients to me, and when I tried it like that, it still wasn't the way she makes them, but it's been a fun challenge to keep working on adapting the recipe. By now it almost feels like, that if I finally manage to make it the way Elise makes them... All this endless solo baking, solo eating, will be over, maybe?</p>
          <p>***** I wrote this in January 2021, and by the time I'm editing this in June I'm able to go to the store again during the day with much less anxiety (about the people there). Snacks and belly fat are back.</p>
          <p>By now I've babbled on for way too long to have space for recipes, and you can figure out most of my simple baking on your own, so here's the main idea....</p>
        </div>
        <div class="content">
          <b-col class="recipe_block">
            <b-row>
              <b-col>
                <p class="recipe_title">  POUR YOURSELF <br> A <br> QUARANTINI</p>
              </b-col>
              <b-col>
                <div class="image_container">
                  <b-img class="img-fluid" id="photo" src="media/magiun2/anise_cup.jpeg"> </b-img>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="recipe">
                  <p>In a mid-sized pan, pour 1L of dark/organic apple juice, or apple cider. Add 2-3 cm raw ginger in thin slices. Add 1 star anise, 3 black peppercorns, 3 whole cloves, and 1 cinnamon stick (or ground). Heat the mix, but don't let it boil.</p>
                  <p>The recipe calls for 400ml of brown rum (I used Kraken, which is nice and spicy already). I used about 200ml, halved the recipe, and ended up adding too much anise in relation, don't recommend, it becomes too licorice-y.</p>
                  <p>You can make it right before you need it and as much as you need, or store it in the fridge.</p>
                  <p>Optional adaptation: Start the other way around, and add all the spices to the rum, instead of the apple juice.</p>
                  <p>My family has a wide range of likes and dislikes and I kept this in mind too much. Mom is on a low carb diet to balance her insulin levels, so I replaced apple juice with zero sugar ginger ale, served cold. My sister doesn't like warm alcoholic drinks, nor ginger. So she got plain cold spiced rum (already infused with ginger, I hoped she wouldn't notice and she didn't). Her boyfriend appreciates fine liquors, so I added a double dose of rum to his mix. In the end, the original recipe was so completely warped, that I ended up making it again for myself on December 31st, solo, the way I wanted to make it.</p>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="recipe_block">
            <b-row>
              <b-col>
                <p class="recipe_title">CHOCOLATE COVERED <br>A N Y T H I N G</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-img class="img-fluid" id="photo" src="media/magiun2/chocolate.jpg"> </b-img>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="recipe">
                  <p>Ingredients<br>
                  - One 100g bar of dark chocolate (72-85%)<br>
                  - About 150g of cut up pieces of dried fruit<br></p>
                  <p>Adaptation<br>
                  - 75g<br>
                  - 100g of anything that tastes great with chocolate!</p>
                  <p>Needed: small wooden spoon, chopsticks.</p>
                  <p>Cut the candied ginger, dried fruit, raisins, nuts, etc. Put a large baking sheet on your counter (place it on a tray or oven rack, so you can move it).</p>
                  <p>Place a small, sturdy ceramic bowl inside a pan with water. Use the burner that's closest to your working area. Bring to a boil and let it simmer low. Break the chocolate into pieces and add to the bowl. Stir with a small wooden spoon until it's all evenly melted.</p>
                  <p>Throw a couple pieces of fruit/nuts into the chocolate and make sure they're fully covered. Use chopsticks to retrieve them, let the excess drip back into the bowl. Lay the candy on the baking sheet, leave a bit of space in between. If you have any chocolate left at the end, you can drip it in a fun shape. When you're all done, place the sheet in the fridge for about 30min or until hard.</p>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import MenuBar from '../MenuBar'
export default {
    name: 'anise',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
